"use client";

import { useEffect, useState } from "react";

// Live relative timestamp. On a statically rendered (ISR) page a
// server-computed "5 min ago" freezes until the next revalidation, which
// misleads users about data freshness. The server renders a neutral
// placeholder and the real value is computed client-side, refreshing each
// minute.

function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  const now = Date.now();
  const diffMin = Math.round((now - then) / 60000);
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin} min ago`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `${diffH} ${diffH === 1 ? "hour" : "hours"} ago`;
  const diffD = Math.round(diffH / 24);
  return `${diffD} ${diffD === 1 ? "day" : "days"} ago`;
}

export function RelativeTime({ iso }: { iso: string }) {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    const update = () => setLabel(formatRelativeTime(iso));
    update();
    const timer = setInterval(update, 60_000);
    return () => clearInterval(timer);
  }, [iso]);

  return <>{label ?? "recently"}</>;
}
